<template>

 	<div class='priceContainer'>
    <span v-html="$t('currencyPrefix')"></span>
    <span v-bind:id="identifier">{{ parsePrice(price) }}</span>
    <span v-html="$t('currencySuffix')" class="prefix" v-if="!currencySuffixVersion || currencySuffixVersion == '1'"></span>
    <span v-html="$t('currencySuffixBuy')" class="prefix" v-if="currencySuffixVersion && currencySuffixVersion == '2'"></span>
 	</div>

</template>

<script>

export default {
  data: function(){
    return{
    	identifier: "",
    	numAnim: false,
  	}

  },

  props: ['currencySuffixVersion'],

  computed:{

    price(){
      var price = parseFloat(this.$store.state.price);
      return price;
    }

  },

  methods: {

    parsePrice(price){

      if(price % 1 != 0)
        return price.toFixed(2)
      else
        return price.toFixed(0)

    },

  	setPrice(){
  		var self = this;
  		//const CountUp = require('countup.js');
  		self.numAnim = new CountUp(this.identifier, 0, self.$store.state.price, 0, 2.5, {
        useEasing : true,
        useGrouping : true,
        separator : ' ',
        decimal : '.',
  		});
  		self.numAnim.start();
  	},

  	updatePrice(){
      if(this.numAnim && typeof this.numAnim.update != 'undefined')
  		  this.numAnim.update(this.$store.state.price);
  	},

  	getID() {
	    var S4 = function() {
	       return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
	    };
	    return "_"+(S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
	 }

  },

  mounted(){

  	var self = this;
  	self.identifier = self.getID();

  }

}
</script>

<style>
.priceContainer{
  display: inline;

  .prefix{
    display: inline-block;
    position: relative;
    left: -3px;
  }

}


</style>



// WEBPACK FOOTER //
// Price.vue?6162425e